.card {
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
}
.interactive {
  cursor: pointer;
  text-decoration: none;
  display: block;
  transition:
    transform var(--transition),
    box-shadow var(--transition);
}
.interactive:hover {
  box-shadow: var(--shadow-md);
}
.interactive:active {
  transform: scale(0.99);
}
.badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px var(--space-2);
  border-radius: var(--radius-full);
  font-size: var(--text-xs);
  font-weight: 600;
  white-space: nowrap;
  background: var(--color-surface-2);
}
.badge-danger {
  background: color-mix(in srgb, var(--color-urgent-now) 14%, transparent);
  color: var(--color-urgent-now);
}
.badge-info {
  background: var(--color-primary-soft);
  color: var(--color-primary);
}
.badge-warning {
  background: var(--color-warning-soft);
  color: var(--color-warning);
}
.badge-success {
  background: var(--color-help-soft);
  color: var(--color-help);
}
.badge-count {
  min-width: 20px;
  justify-content: center;
  background: var(--color-text);
  color: var(--color-bg);
}
.avatar {
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--color-primary-soft);
  color: var(--color-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  overflow: hidden;
}
.avatarWrap {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}
.onlineDot {
  position: absolute;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  background: #22a559;
  box-shadow: 0 0 0 2px var(--color-surface);
}
.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.chip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  min-height: 40px;
  padding: 0 var(--space-3);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-full);
  background: var(--color-surface);
  cursor: pointer;
  font-size: var(--text-sm);
  font-weight: 500;
}
/* Chosen chips: a firm outline and bold text on a light tint — clear, but not loud. */
.chipActive {
  border-color: var(--color-primary);
  box-shadow: inset 0 0 0 1px var(--color-primary);
  background: var(--color-primary-soft);
  color: var(--color-text);
  font-weight: 800;
}
.tabs {
  display: flex;
  gap: var(--space-1);
  padding: var(--space-1);
  background: var(--color-surface-2);
  border-radius: var(--radius-md);
}
.tab {
  flex: 1;
  min-height: 40px;
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  cursor: pointer;
  font-weight: 600;
  color: var(--color-text-muted);
}
.tabActive {
  background: var(--color-surface);
  color: var(--color-text);
  box-shadow: var(--shadow-sm);
}
.skeleton {
  border-radius: var(--radius-md);
  background: linear-gradient(
    90deg,
    var(--color-surface-2) 25%,
    var(--color-border) 50%,
    var(--color-surface-2) 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.2s infinite;
}
@keyframes shimmer {
  to {
    background-position: -200% 0;
  }
}
.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--space-3);
  padding: var(--space-8) var(--space-4);
}
.stateIcon {
  font-size: 44px;
}
.loader {
  display: flex;
  justify-content: center;
  padding: var(--space-8);
}
.loaderMark {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.loaderPin {
  width: 52px;
  height: 52px;
  animation: pinHop 1s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}
.loaderHeart {
  transform-origin: 256px 224px;
  animation: heartBeat 1s ease-in-out infinite;
}
.loaderShadow {
  width: 26px;
  height: 6px;
  margin-top: -4px;
  border-radius: 50%;
  background: var(--color-text);
  opacity: 0.18;
  animation: pinShadow 1s cubic-bezier(0.45, 0, 0.55, 1) infinite;
}
@keyframes pinHop {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}
@keyframes pinShadow {
  0%,
  100% {
    transform: scaleX(1);
    opacity: 0.18;
  }
  50% {
    transform: scaleX(0.6);
    opacity: 0.08;
  }
}
@keyframes heartBeat {
  0%,
  60%,
  100% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.18);
  }
}
@media (prefers-reduced-motion: reduce) {
  .loaderPin,
  .loaderHeart,
  .loaderShadow {
    animation-duration: 2.4s;
  }
  .loaderPin,
  .loaderShadow {
    animation-name: none;
  }
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
